import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormViewerComponent } from '../form-viewer/form-viewer.component';

@Component({
    selector: 'app-admin-form-viewer',
    templateUrl: './admin-form-viewer.component.html',
    styleUrl: './admin-form-viewer.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        FormViewerComponent
    ]
})
export class AdminFormViewerComponent implements OnInit {

    params = signal<{type: number, pi: {id: number, procedureFormId: number, serviceInstanceId: number, procedureInstanceCode: number, state: number}} | null>(null)
    
    constructor(private activatedRoute: ActivatedRoute) { }   

    ngOnInit(): void {

        // E2 //
        // http://localhost:4500/form-viewer?type=0&id=10009238&procedureFormId=11626&serviceInstanceId=9081047&procedureInstanceCode=402672&state=0

        // PREVIEW //
        // http://localhost:4500/form-viewer?type=0&id=9772154&procedureFormId=12121&serviceInstanceId=8871638&procedureInstanceCode=100000235&state=0

        // DRAFT //
        // http://localhost:4500/form-viewer?type=1&id=9702340&procedureFormId=12121&serviceInstanceId=8809043&procedureInstanceCode=100000016&state=4
        // http://localhost:4200/home/catproc/public-procedure?serviceInstanceCode=100000005&procedureInstanceCode=100000016

        this.activatedRoute.queryParamMap.subscribe(qp => {

            let type = qp.get("type")
            let id = qp.get("id")
            let procedureFormId = qp.get("procedureFormId")
            let serviceInstanceId = qp.get("serviceInstanceId")
            let state = qp.get("state")

            let procedureInstanceCode = qp.get("procedureInstanceCode")

            if (type == null || id == null || procedureFormId == null || serviceInstanceId == null || state == null || procedureInstanceCode == null) {
                alert('Faltan parametros')
                return
            }

            this.params.set({
                type: parseInt(type),
                pi: {
                    id: parseInt(id),
                    procedureFormId: parseInt(procedureFormId),
                    serviceInstanceId: parseInt(serviceInstanceId),
                    procedureInstanceCode: parseInt(procedureInstanceCode),
                    state: parseInt(state)
                }
            })
        })

    }

}
